import React from "react";

export default function ConfigTabs(props) {
  const accountConfigPath = "/datapulse/account-config";
  const seoConfigPath = "/datapulse/seo-config";
  const ppcConfigPath = "/datapulse/ppc-config";

  return (
    <>
      <div className="mt-3 nav-fill tabs-navigation row no-gutters row-cols-sm-1 row-cols-md-3 nav nav-pills" role="tablist">
        <div className="col nav-item">
          {props.selectedTab == "account" ? (
            <a href={accountConfigPath} className="nav-link active" data-rb-event-key="account" data-link-type="base" id="base-tabs-account">
              Account Configuration
            </a>
          ) : (
            <a href={accountConfigPath} className="nav-link" data-rb-event-key="account" data-link-type="base" id="base-tabs-account">
              Account Config
            </a>
          )}
        </div>
        <div className="col nav-item">
          {props.selectedTab == "ppc" ? (
            <a href={ppcConfigPath} className="nav-link active" data-rb-event-key="ppc" data-link-type="base" id="base-tabs-ppc">
              PPC Config
            </a>
          ) : (
            <a 
              href={ppcConfigPath}
              className={`nav-link ${props.enabledServices.ppc == false ? "disabled" : ""}`}
              style={{opacity: props.enabledServices.ppc == false ? "0.5" : ""}}
              data-rb-event-key="ppc"
              data-link-type="base"
              id="base-tabs-ppc"
            >
              PPC Config
            </a>
          )}
        </div>
        <div className="col nav-item">
          {props.selectedTab == "seo" ? (
            <a href={seoConfigPath} className="nav-link active" data-rb-event-key="seo" data-link-type="base" id="base-tabs-seo">
              SEO Config
            </a>
          ) : (
            <a
              href={seoConfigPath}
              className={`nav-link ${props.enabledServices.seo == false ? "disabled" : ""}`}
              style={{opacity: props.enabledServices.seo == false ? "0.5" : ""}}
              data-rb-event-key="seo"
              data-link-type="base"
              id="base-tabs-seo"
            >
              SEO Config
            </a>
          )}
        </div>
      </div>
    </>
  );
}
